export default "__VITE_ASSET__0gYQGb9y__"